'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { usePostHog } from 'posthog-js/react';
import { useEffect, useRef } from 'react';

import { IQueryData } from '@Reducers/common';
import { useAppSelector } from '@Redux/hooks';
import { UserRole } from '@Utils/constants';
import { LOG_ERROR } from '@Utils/logger';

import { AlloAuthUser } from './auth/utils';

export default function PostHogPageView(): null {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const posthog = usePostHog();
  const auth: AlloAuthUser = useAppSelector((state) => state.auth.user);
  const queryData: IQueryData = useAppSelector((state) => state.common.queryData);
  const queryDataRef = useRef<IQueryData>();
  queryDataRef.current = queryData;

  useEffect(() => {
    // Track pageviews
    if (pathname && posthog && auth?.roles.includes(UserRole.PATIENT)) {
      let url = window.origin + pathname;
      if (searchParams.toString()) {
        url = url + `?${searchParams.toString()}`;
      }
      const payload = {
        $current_url: url,
        consultation_code: queryDataRef.current?.consultationCode,
        location: queryDataRef.current?.locationCode,
        selected_languages: queryDataRef.current?.selectedLanguages,
        consultation_id: queryDataRef.current?.consultationId,
        appointment_state: queryDataRef.current?.appointmentState,
      };
      try {
        posthog.capture('$pageview', payload);
      } catch (error) {
        LOG_ERROR('Error capturing posthog pageview', error);
      }
    }
  }, [pathname, searchParams, posthog]);

  return undefined;
}
